import React from "react";
// import Logo1 from "../Assets/Group 9.png";
import Logo1 from "../Assets/Group 8 3.png";
import UpperArrow from "../Assets/UpperArrow.svg";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faInstagram, faYoutube } from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
    const navigate = useNavigate();
    const navigateto = (data) => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        navigate(`/${data}`)
    }
    return (
        <footer className="footer">
            <div className="footer-top">
                <div className="footer-content">
                    <h2>Looking To Sell or Rent Your Property</h2>
                    <button className="contact-buttonFooter">
                        Contact Now
                        {/* <img style={{width:'40px',height:'40px'}} src={UpperArrow} alt="UpperArrow" /> */}
                    </button>
                </div>
            </div>
            <div className="footer-bottom">
                <div className="footer-section">
                    <div className="logo-section">
                        <img src={Logo1} alt="ADL Logo" />
                        <p style={{ color: 'black' }}>Transforming Real Estate with Integrity and Innovation</p>
                    </div>
                </div>
                <div className="footer-section">
                    <h3>Pages</h3>
                    <ul>
                        <li onClick={() => { navigateto('') }}>Home</li>
                        <li onClick={() => { navigateto('AboutUs') }}>About</li>
                        <li onClick={() => { navigateto('Properties') }}>Properties</li>
                        <li onClick={() => { navigateto('Blogs') }}>Blog</li>
                        <li onClick={() => { navigateto('ContactUs') }}>Contact Us</li>
                        <li onClick={() => { navigateto('SignUp') }}>Sign Up</li>
                    </ul>
                </div>
                <div className="footer-section">
                    <h3>Utility Pages</h3>
                    <ul>
                        <li onClick={() => { navigateto('PrivacyPolicy') }}>Privacy & Policy</li>
                        <li onClick={() => { navigateto('Termsandcondition') }}>Term & Condition</li>
                    </ul>
                </div>
            </div>
            <div className="footer-end1">
                <div className="social-icons">
                    <a href="https://www.instagram.com/adl_realtors?igsh=cGdtbGhsYjlkbmJn&utm_source=qr" target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faInstagram} className="social-icon instagram" />
                    </a>
                    <a href="https://www.facebook.com/share/1B9Azcf12s/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faFacebook} className="social-icon facebook" />
                    </a>
                    <a href="https://youtube.com/@adlrealtors?feature=shared" target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faYoutube} className="social-icon youtube" />
                    </a>
                </div>
            </div>
            <div className="footer-end">
                <p>Copyright © ADL. All rights reserved. </p>
                <p></p>
            </div>
        </footer>
    );
};

export default Footer;
